var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('salaryTop',{attrs:{"step":_vm.step},on:{"update:step":function($event){_vm.step=$event},"setStep":_vm.setStep}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }